import { render, staticRenderFns } from "./ViolationAction.vue?vue&type=template&id=91c23b82"
import script from "./ViolationAction.vue?vue&type=script&lang=js"
export * from "./ViolationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports